import request from './request.js';
import {requestbody} from './request.js'
export async function querycell(params = {

}) {
    return await requestbody('/manuscript/query/cell', 'post', params)
}
//城镇土地税独有获取
export async function manuscriptqueryCztdCell(params = {

}) {
    return await requestbody('/manuscript/queryCztdCell', 'post', params)
}
//城镇土地独有保存
export async function savecztdCell(params = {

}) {
    return await requestbody('/manuscript/save/cztdCell', 'post', params)
}
//查询当前申报周期
export async function tax_ty(params = {

}) {
    return await requestbody('/sys/tax/edit/ty', 'post', params)
}
//房产税独有获取
export async function queryFcsCell(params = {

}) {
    return await requestbody('/manuscript/queryFcsCell', 'post', params)
}
//房产税独有获取
export async function fcsTemplate(params = {

}) {
    return await requestbody('/templateEx/query/fcs/template', 'post', params)
}
//房产税独有获取
export async function tdsTemplate(params = {

}) {
    return await requestbody('/templateEx/query/tds/template', 'post', params)
}

//操作记录房产税独有获取
export async function fcTrack(params = {

}) {
    return await requestbody('/report/query/fc/report/track', 'post', params)
}
//操作记录房产税独有获取
export async function tdTrack(params = {

}) {
    return await requestbody('/report/query/td/report/track', 'post', params)
}
//房产税独有保存
export async function savefcsCell(params = {

}) {
    return await requestbody('/manuscript/save/fcsCell', 'post', params)
}

export async function writesave(params = {

}) {
    return await requestbody('/manuscript/write/save', 'post', params)
}
export async function startShenBao(params = {

}) {
    return await requestbody('/manuscript/startShenBao', 'post', params)
}
// 一键生成底稿
export async function forShengcdg(params = {

}) {
    return await requestbody('/manuscript/generat', 'post', params)
}
// 临时登录
export async function login(params = {

}) {
    return await requestbody('/login', 'post', params)
}
//底稿生成查询
export async function manuscriptquery(params = {

}) {
    return await requestbody('/manuscript/query', 'post', params)
}
//上传文件
export async function manuscriptUploadFile(params = {

}) {
    return await request('/manuscript/uploadFile', 'post', params)
}
//保存附件
export async function annexadd(params = {

}) {
    return await request('/manuscript/annex/add', 'post', params)
}
//附件记录查询
export async function queryAttachmentList(params = {

}) {
    return await requestbody('/manuscript/queryAttachmentList', 'post', params)
}
//下载
export async function annexdownloads(params = {

}) {
    return await requestbody('/manuscript/annex/downloads', 'post', params)
}
//删除
export async function annexdelete(params = {

}) {
    return await requestbody('/manuscript/annex/delete', 'post', params)
}

//提交审核
export async function submitAudit(params = {

}) {
    return await request('/manuscript/submitAudit', 'post', params)
}
//导出列表
export async function manuscriptexport(params = {

}) {
    return await requestbody('/manuscript/export', 'post', params)
}
//取消审核
export async function manuscriptcancelAudit(params = {

}) {
    return await requestbody('/manuscript/cancelAudit', 'post', params)
}
//
export async function manuscriptqueryReportStep(params = {

}) {
    return await request('/manuscript/queryReportStep', 'post', params)
}
//
export async function manuscriptwriteimport(params = {

}) {
    return await request('/manuscript/write/import', 'post', params)
}

//申报缴款 ---------
export async function manuscriptzfbc(params = {

}) {
    return await requestbody('/manuscript/zfbc', 'post', params)
}
//一键申报
export async function manuscriptstartShenBao(params = {

}) {
    return await requestbody('/manuscript/startShenBao', 'post', params)
}
// 申报更正
export async function manuscriptstartCorrections(params = {}) {
    return await requestbody('/manuscript/startCorrections', 'post', params)
}
//刷新
export async function refreshReport(params = {

}) {
    return await requestbody('/manuscript/refreshReport', 'post', params)
}

//缴款申请
export async function loadPaymentTask(params = {

}) {
    return await request('/manuscript/loadPaymentTask', 'post', params)
}
//下载pdf
export async function downloadPdf(params = {

}) {
    return await request('/manuscript/downloadPdf', 'post', params)
}
//下载pdf
export async function manuscriptrole(params = {

}) {
    return await request('/manuscript/manuscript/role', 'post', params)
}
//
export async function getShenBaoDiscount(params = {

}) {
    return await request('/manuscript/getShenBaoDiscount', 'post', params)
}
	

//查看附件
// export async function queryAttachmentList(params = {

// }) {
//     return await request('manuscript/queryAttachmentList', 'post', params)
// }

//税目
export async function sysYhsSm(params = {

}) {
    return await requestbody('/sys/getYhsSm', 'post', params)
}
//映射接口
export async function queryCompanyShuibDict(params = {

}) {
    return await requestbody('sys/queryCompanyShuibDict', 'post', params)
}
//城镇土地初始化数据
export async function landinit(params = {

}) {
    return await requestbody('/land/init', 'post', params)
}
//上传注件
export async function UploadNotes(params = {

}) {
    return await request('/manuscript/uploadCwbbFile', 'post', params)
}
//附注查询

export async function queryNotes(params = {

}) {
    return await request('/manuscript/getCwbbFile', 'post', params)
}
//印花税次报查询
export async function queryCompanyList(params = {

}) {
    return await request('/sys/queryCompanyList', 'post', params)
}

//印花税次报提交
export async function addyhsTime(params = {

}) {
    return await request('manuscript/extend/add/yhsTime', 'post', params)
}
//印花税次报删除
export async function delete_yhsReport(params = {

}) {
    return await request('manuscript/extend/delete/yhsReport', 'post', params)
}
//风险计算数量
export async function calculateByReportRisk(params = {

}) {
    return await request('/managementEx/calculateByReportRisk', 'post', params)
}
//风险详情
export async function queryRiskDetail(params = {

}) {
    return await requestbody('/managementEx/queryRiskDetail', 'post', params)
}
//修改更正说明
export async function modifyMessage(params = {

}) {
    return await requestbody('/manuscript/modifyMessage', 'post', params)
}
//残保金查询
export async function findConpanyConfig(params = {

}) {
    return await request('/sys/findConpanyConfig', 'post', params)
}
//审核流程查询
export async function auditFlow(params = {

}) {
    return await request('/audit/query/auditFlow', 'post', params)
}
//请求获取是否上传附注
export async function checkIsUploadFz(params = {

}) {
    return await request('/manuscript/extend/checkIsUploadFz', 'post', params)
}
//判断弹框
export async function queryDialog(params = {

}) {
    return await request('/manuscript/extend/queryDialog', 'post', params)
}

//查询附注内容
export async function query_Appended(params = {

}) {
    return await requestbody('/cwbb_appended/query_Appended', 'post', params)
}
//添加
export async function cwbb_appended_save(params = {

}) {
    return await requestbody('/cwbb_appended/save', 'post', params)
}
//修改
export async function cwbb_appended_update(params = {

}) {
    return await requestbody('/cwbb_appended/update', 'post', params)
}
export async function get_info_by_no(params = {
}) {
    return await requestbody('/xfs_xfp_info/get_info_by_no', 'post', params)
}

//更新申报状态
export async function updateTheFilingStatus(params = {

}) {
    return await requestbody('/manuscript/updateTheFilingStatus', 'post', params)
}

//获取企业所得税V2所需的校验数据
export async function queryCheckData(params = {

}) {
    return await requestbody('/manuscript/query/checkData', 'post', params)
}

export async function financialReportHint(params = {

}) {
    return await requestbody('/manuscript/financialReportHint', 'post', params)
}

export async function manuscriptSaveVerified(params = {

}) {
    return await requestbody('/manuscript/manuscriptSaveVerified', 'post', params)
}